import { ApiClient } from './classes/ApiClient'

export { default as routes } from './routes'
export const api = new ApiClient(process.env.VUE_APP_API_URL + '/v' + process.env.VUE_APP_API_VERSION + '/')
